var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"d-flex"},[_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.fields),function(item,index){return _c('v-list-item',{key:index,staticClass:"contact-address",domProps:{"innerHTML":_vm._s(item)}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }